import { useLocation } from 'react-router-dom';

export const Language = () => {
  const location = useLocation();
  const { pathname } = location;
  if (pathname.split('/')[1] === 'ja') {
    return 'japan';
  }
  return 'english';
};

export default Language;
